import { createContext, MouseEvent, useContext } from "react";

export const mobileNavContext = createContext<{ onLinkClick(e: MouseEvent<HTMLAnchorElement>): void } | null>(null);

export const useMobileNavCtx = () => {
  const context = useContext(mobileNavContext);

  return context;
}